module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content",
    staticStyle: {
      "background-color": "#fafafa",
      "z-index": "9999"
    }
  }, [_c('div', {
    staticClass: "mod",
    staticStyle: {
      "height": "100vh"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "color"
  }), _vm._v(" "), _c('div', {
    staticClass: "bd"
  }, [_c('div', {
    staticClass: "group_2"
  }, [_c('div', {
    staticClass: "group_3"
  }, [_c('span', {
    staticClass: "text"
  }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
    staticClass: "container_1"
  }, [_c('span', {
    staticClass: "txt_1",
    on: {
      "click": function($event) {
        return _vm.autofocus('customerName')
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.customerName),
      expression: "customerName",
      modifiers: {
        "trim": true
      }
    }],
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "id": "customerName",
      "placeholder": "请填写您的姓名"
    },
    domProps: {
      "value": (_vm.customerName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.customerName = $event.target.value.trim()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "wrap",
    on: {
      "click": function($event) {
        return _vm.autofocus('customerName')
      }
    }
  }, [_c('img', {
    staticClass: "icon_5",
    attrs: {
      "src": "/static/img/修 改.svg"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "block_3"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "/static/img/authentication13.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container_2"
  }, [_c('span', {
    staticClass: "word_1"
  }, [_vm._v("手机")]), _vm._v(" "), _c('div', {
    staticClass: "outer_1"
  }, [_c('span', {
    staticClass: "phone"
  }, [_vm._v(_vm._s(_vm.mobile))]), _vm._v(" "), _vm._m(0)])])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('span', {
    staticClass: "desc"
  }, [_vm._v("4. 手机号为登录时使用手机号，无法更改")]), _vm._v(" "), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "footer-content",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "add-btn research-background-color",
    staticStyle: {
      "text-align": "center",
      "padding-top": "12px"
    },
    on: {
      "click": _vm.goShowConfirmedButton
    }
  }, [_c('span', [_vm._v("发起签署")])])])]), _vm._v(" "), _c('footer-placeholder')], 1)])]), _vm._v(" "), (_vm.showConfirmedButton) ? _c('div', {
    staticClass: "background-modal"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showConfirmedButton),
      expression: "showConfirmedButton"
    }],
    staticClass: "choose-balance-account",
    staticStyle: {
      "margin-bottom": "350px",
      "margin-left": "10%",
      "margin-right": "10%",
      "border-radius": "12px"
    }
  }, [_c('div', {
    staticClass: "content-block",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "message_customer"
  }, [_c('div', [_c('span', [_vm._v("姓名: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.customerName))])]), _vm._v(" "), _c('div', [_c('span', [_vm._v("手机: ")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.mobile))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "70px"
    }
  }, [_c('img', {
    staticClass: "bg_1",
    attrs: {
      "src": "/static/img/authentication13.png"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('div', {
    staticStyle: {
      "float": "left",
      "width": "50%"
    },
    on: {
      "click": function($event) {
        _vm.showConfirmedButton = false
      }
    }
  }, [_c('span', [_vm._v("\r\n           返回修改\r\n         ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "width": "50%"
    },
    on: {
      "click": _vm.sendAuthentication
    }
  }, [_c('span', {
    staticStyle: {
      "color": "#576B95"
    }
  }, [_vm._v("确认发起")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block_4"
  }, [_c('img', {
    staticClass: "icon_6",
    attrs: {
      "src": "/static/img/锁.svg"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "submain"
  }, [_c('span', {
    staticClass: "info"
  }, [_vm._v("1. 请确保您的姓名为")]), _vm._v(" "), _c('span', {
    staticClass: "word_2"
  }, [_vm._v("真实姓名，")]), _vm._v(" "), _c('span', {
    staticClass: "info_1"
  }, [_vm._v("否则会导致")]), _vm._v(" "), _c('span', {
    staticClass: "txt_2"
  }, [_vm._v("签署失败")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('span', {
    staticClass: "info_2"
  }, [_vm._v("2. 请确保您的姓名与")]), _vm._v(" "), _c('span', {
    staticClass: "organizationPrev"
  }, [_vm._v("手机号码实名机主")]), _vm._v(" "), _c('span', {
    staticClass: "organization"
  }, [_vm._v("一致")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row1"
  }, [_c('span', {
    staticClass: "word_3"
  }, [_vm._v("3. 手机号已")]), _vm._v(" "), _c('span', {
    staticClass: "text_1"
  }, [_vm._v("开通支付宝")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "14px",
      "font-size": "10px",
      "font-weight": "300",
      "color": "#929292",
      "line-height": "14px",
      "margin-bottom": "10px",
      "text-align": "center"
    }
  }, [_vm._v("\r\n       点击发起签署，"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("e签宝")]), _vm._v("认证链接会以"), _c('span', {
    staticStyle: {
      "color": "#5878FA"
    }
  }, [_vm._v("短信")]), _vm._v("形式发送到您的手机上\r\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "justify-content": "center",
      "margin-top": "15px",
      "margin-bottom": "10px"
    }
  }, [_c('span', {
    staticClass: "deep-text-color",
    staticStyle: {
      "text-align": "center",
      "width": "272px",
      "height": "24px",
      "font-size": "17px",
      "font-family": "PingFangSC-Medium, PingFang SC",
      "font-weight": "500",
      "color": "#000000",
      "line-height": "24px"
    }
  }, [_vm._v("确认信息")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3da4d5e7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Authentication/authenticationHome.vue
// module id = 1609
// module chunks = 8